/* Opens the Lens Guide in a full-screen overlay.
   The storefront CSP forbids iframes, so the guide page is fetched
   and injected inline. Triggers: same-origin links with [data-lens-guide-open]. */
(function () {
  if (window.__lensGuideModal) return;
  window.__lensGuideModal = true;

  var modal, holder, opener, isOpen = false;
  var state = 'idle'; /* idle | loading | ready | failed */
  var wantOpen = false;

  var css =
    '.lens-guide-modal{position:fixed;inset:0;z-index:999999;background:#0B0C0F;display:none;overflow:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}' +
    '.lens-guide-modal.is-open{display:block}' +
    '.lens-guide-modal__holder{position:relative;z-index:1;min-height:100%;opacity:0;transition:opacity .25s ease}' +
    '.lens-guide-modal.is-loaded .lens-guide-modal__holder{opacity:1}' +
    '.lens-guide-modal.is-loaded .lens-guide-modal__spin{display:none}' +
    '.lens-guide-modal__spin{position:fixed;top:50%;left:50%;width:36px;height:36px;margin:-18px 0 0 -18px;' +
    'border:3px solid rgba(255,255,255,.2);border-top-color:#fff;border-radius:50%;animation:lg-spin .8s linear infinite}' +
    '@keyframes lg-spin{to{transform:rotate(360deg)}}' +
    '@media (prefers-reduced-motion:reduce){.lens-guide-modal__holder{transition:none}}' +
    /* app launchers (Smile.io) use max z-index — hide them while the guide is open */
    'html.lens-guide-open #smile-ui-container{display:none !important}';

  function ensureModal() {
    if (modal) return;
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    modal = document.createElement('div');
    modal.className = 'lens-guide-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Lens guide');
    modal.setAttribute('tabindex', '-1');
    modal.innerHTML = '<span class="lens-guide-modal__spin"></span>';
    holder = document.createElement('div');
    holder.className = 'lens-guide-modal__holder';
    modal.appendChild(holder);
    document.body.appendChild(modal);
  }

  function addHeadLink(href) {
    if (!href || document.querySelector('link[href="' + href + '"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  function load(href) {
    if (state !== 'idle') return;
    state = 'loading';
    ensureModal();

    function fail() {
      state = 'failed';
      if (wantOpen) { hide(); location.href = href; }
    }

    fetch(href, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('.lens-guide');
        var data = doc.getElementById('LensGuideData');
        var js = doc.querySelector('script[src*="lens-guide.js"]');
        if (!root || !data || !js) { fail(); return; }
        window.__lensGuideSrc = href;
        var links = doc.querySelectorAll('link[rel="stylesheet"]');
        Array.prototype.forEach.call(links, function (l) {
          var h = l.getAttribute('href') || '';
          if (h.indexOf('lens-guide') > -1 || h.indexOf('fonts.googleapis') > -1) addHeadLink(h);
        });
        holder.appendChild(root);
        holder.appendChild(data);
        var s = document.createElement('script');
        s.src = js.getAttribute('src');
        s.addEventListener('load', function () {
          state = 'ready';
          modal.classList.add('is-loaded');
        });
        s.addEventListener('error', fail);
        document.head.appendChild(s);
      })
      .catch(fail);
  }

  function show(href) {
    if (state === 'failed') { location.href = href; return; }
    ensureModal();
    load(href);
    wantOpen = true;
    opener = document.activeElement;
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('lens-guide-open');
    isOpen = true;
    try { history.pushState({ lensGuide: true }, ''); } catch (e) {}
    modal.focus();
  }

  function hide() {
    if (!isOpen) return;
    isOpen = false;
    wantOpen = false;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('lens-guide-open');
    if (opener && opener.focus) opener.focus();
  }

  /* back out of the pushed history entry so Back keeps working naturally */
  function requestClose() {
    if (!isOpen) return;
    if (history.state && history.state.lensGuide) history.back();
    else hide();
  }

  function linkFrom(e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-lens-guide-open]') : null;
    if (!a || !a.href) return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return null; }
    return u.origin === location.origin ? u.href : null;
  }

  document.addEventListener('click', function (e) {
    var href = linkFrom(e);
    if (!href) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (state === 'failed') return;
    e.preventDefault();
    show(href);
  });

  /* warm the guide on hover / first touch so opening feels instant */
  document.addEventListener('pointerover', function (e) {
    var href = linkFrom(e);
    if (href) load(href);
  }, { passive: true });
  document.addEventListener('touchstart', function (e) {
    var href = linkFrom(e);
    if (href) load(href);
  }, { passive: true });

  document.addEventListener('lens-guide:close', function (e) {
    e.preventDefault();
    requestClose();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') requestClose();
  });
  window.addEventListener('popstate', hide);
})();
